/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Container } from "../Section";
import CallUs from "../CallUs";
import Map from "../Map";
import DesignBuilding from "../DesignBuilding";
import AddressList from "../AddressList";
import StateManufacturerAccordion from "../StateManufacturerAccordion";


const FooterWrap = styled.footer`
  position: relative;
`;
const FooterContainer = styled.div`
  position: relative;
  background-color: #1d1d1d;
`;

const FooterTop = styled.div`
  position: relative;
  padding: 40px 0 20px 0;
  @media (min-width: 1200px) {
    padding: 60px 0 30px 0;
  }

  .accordions {
    .accordions-items {
      padding: 0;
      &.active {
        .accordions-title {
          span {
            &:after,
            &:before {
              background: #fff;
            }
          }
        }
      }
    }
    .accordions-title {
      font-style: inherit;
      font-weight: 700;
      color: #fff;
      text-transform: uppercase;
      border-bottom: 1px solid #484b58;
      padding: 0 0 30px;
      margin: 0 0 30px;
    }
    .accordions-content {
      ul {
        list-style: none;
        padding: 0px;
        margin: 0px 0px 30px;
        font-size: 16px;
        line-height: 30px;
        column-count: 4;
        color: #fff;
      }
    }
  }
`;
const MenuGrid = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 100%;
  margin: 0 -10px;
  border-bottom: 1px solid #484b58;
`;
const MenuItemGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  &.menu-item {
    flex: 0 0 50%;
    max-width: 50%;
    &:first-child {
      @media (min-width: 576px) {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    }
    @media (min-width: 992px) {
      flex: 0 0 25%;
      max-width: 25%;
      + .menu-item {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    }
    &:nth-child(3) {
      @media (max-width: 575.98px) {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
    &:last-child {
      flex: 0 0 100%;
      max-width: 100%;
      @media (min-width: 576px) {
        flex: 0 0 50%;
        max-width: 50%;
      }
      @media (min-width: 992px) {
        flex: 0 0 25%;
        max-width: 25%;
      }
      @media (min-width: 1200px) {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
      }
    }
  }
  .embed-responsive {
    margin-bottom: 30px;
  }
`;
const MenuTitle = styled.div`
  font-weight: 700;
  color: #E9242A;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 26px;
  @media (min-width: 576px) {
    font-size: 20px;
    line-height: 30px;
  }
`;
const AddressBlock = styled.div`
  margin: 0 0 30px;
  .list-title {
    color: #E9242A;
  }
`;
const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  @media (min-width: 576px) {
    font-size: 16px;
    line-height: 30px;
  }
`;
const MenuItem = styled.li`
  margin: 0;
  padding: 0;
  + li {
    margin-top: 8px;
  }
  & a {
    display: inline-block;
    color: #fff;
    position: relative;
    &:hover {
      color: #E9242A;
    }
  }
`;

const FooterBottom = styled.div`
  position: relative;
  background-color: #484b58;
  padding: 20px 0 75px;
  @media (min-width: 768px) {
    padding: 20px 0;
  }
`;
const FooterMiddle = styled.div`
  position: relative;

  padding: 0 0 20px 0;
  @media (min-width: 1200px) {
    padding: 0 0 30px 0;
  }
`;
const Copyright = styled.div`
  font-family: "Oxanium", serif;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5px;
  font-size: 12px;
  line-height: 20px;
  @media (min-width: 576px) {
    font-size: 14px;
    line-height: 24px;
  }
  & a {
    position: relative;
    display: inline-block;
    color: #fff;
    &:after {
      -webkit-transition: -webkit-transform 0.3s;
      transition: transform 0.3s;
      background: rgba(255, 255, 255, 0.4);
      content: "";
      position: absolute;
    }
    &:after {
      top: 110%;
      left: 0;
      width: 100%;
      height: 2px;
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
    }

    &:hover {
      color: #fff;
      &:after {
        transform: scaleX(1);
      }
    }
  }
`;
const BBBTag = styled.div`  
  @media (min-width: 992px) {
    display:none;
  }
`;

const Footer = ({ location }) => {
  const [thanksURL, setThanksURL] = useState("");

  useEffect(() => {
    let thxURL = "";
    if (
      location.pathname === "/" ||
      location.pathname === "/about-us" ||
      location.pathname === "/projects" ||
      location.pathname === "/shop" ||
      location.pathname === "/rent-to-own-metal-buildings" ||
      location.pathname === "/financing" ||
      location.pathname === "/contact-us" ||
      location.pathname === "/service-area" ||
      location.pathname === "/sitemap"
    ) {
      thxURL = "/thank-you-request-a-quote";
    } else {
      thxURL = "/thank-you-manufacturer";
    }
    setThanksURL(thxURL);
  }, []);
  return (
    <>
      <CallUs location={location} thanksURL={thanksURL} />
      <DesignBuilding />
      <FooterWrap>
        <FooterContainer>
          <FooterTop>
            <Container>
              <MenuGrid className="menu-grid">
                <MenuItemGrid className="menu-item">
                  <MenuTitle>Building Styles</MenuTitle>
                  <MenuList>
                    <MenuItem>
                      <Link to="/metal-carports">Carports</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/metal-garages">Garages</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/rv-carports">RV Carports</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/metal-barns">Barns</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/metal-sheds">Sheds</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/utility-buildings/">Utility Buildings</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/storage-buildings/">Storage Buildings</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/commercial-buildings/">Commercial Buildings</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/workshop-buildings/">Workshop Buildings</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/warehouse-buildings/">Warehouse Buildings</Link>
                    </MenuItem>
                  </MenuList>
                </MenuItemGrid>
                <MenuItemGrid className="menu-item">
                  <MenuTitle>Quick Links</MenuTitle>
                  <MenuList>
                    <MenuItem>
                      <Link to="/shop">Shop Now</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/compare">Compare</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/about-us">About Us</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/service-area">Service Area</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/color-options">Color Options</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/financing">Financing</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/faqs">Building FAQs</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/ordering-process">Order Process</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/site-preparation">Site Preparation</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/contact-us">Contact Us </Link>
                    </MenuItem>
                  </MenuList>
                </MenuItemGrid>
                <MenuItemGrid className="menu-item">
                  <AddressBlock><AddressList /></AddressBlock>
                </MenuItemGrid>
                <MenuItemGrid className="menu-item">
                  <Map />
                  <BBBTag>
                    <a href="https://www.bbb.org/us/id/heyburn/profile/metal-building-contractors/emb-metal-buildings-llc-idaho-1296-1000182247/#sealclick" target="_blank" rel="nofollow noreferrer" ><img src="https://seal-alaskaoregonwesternwashington.bbb.org/seals/blue-seal-187-130-whitetxt-bbb-1000182247.png" alt="EMB Metal Buildings LLC Idaho BBB Business Review" /></a>
                  </BBBTag>
                </MenuItemGrid>
              </MenuGrid>
            </Container>
          </FooterTop>
          <FooterMiddle>
            <Container>
              <StateManufacturerAccordion />
            </Container>
          </FooterMiddle>
          <FooterBottom>
            <Container>
              <Copyright>
                Copyright © {new Date().getFullYear()} EMB Metal Buildings LLC.
                | All Rights Reserved |{" "}
                <Link to="/privacy-policy/">Privacy Policy</Link> |{" "}
                <Link to="/shopping-policy">Shopping Policy</Link> |{" "}
                <Link to="/terms-and-conditions/">Terms & Conditions</Link>
              </Copyright>
            </Container>
          </FooterBottom>
        </FooterContainer>
      </FooterWrap>
    </>
  );
};

export default Footer;
